import {ICell, ICellMetricAggregator} from "./PA.HyperRectangle.IF";
import * as _ from 'lodash'
import {EvalFunction} from "mathjs";

export class ComputedAggr
    implements ICellMetricAggregator
{
    private _metricFormula: string
    private _metricFunction: EvalFunction
    private _scopeMetrics: string[]
    private _count: number
    private _errorCount: number
    private _sum: number
    private _dfltValue: number
    private _bWriteBack: boolean
    private _writeBackMetricIds: string[]

    constructor(metricFormula: string,
                metricFunction:  EvalFunction,
                scopeMetrics: string[],
                defaultValue?: number,
                writeBackMetricIds?: string[])
    {
        this._metricFormula = metricFormula
        this._metricFunction = metricFunction
        this._scopeMetrics = scopeMetrics
        this._sum = 0
        this._count = 0
        this._dfltValue = defaultValue || 0
        this._bWriteBack = !_.isEmpty(writeBackMetricIds)
        this._writeBackMetricIds = writeBackMetricIds || []
    }

    add(cell: ICell, scaleFactor: number): void {

        this._count += 1
        let scope: any = {}
        _.forEach(this._scopeMetrics, (aMetricName) => {
            scope[aMetricName] = cell.getCellMetricValue(aMetricName)
        })

        try {
            //--
            let results = this._metricFunction.evaluate(scope)
            if (_.isNumber(scaleFactor))
                results *= scaleFactor
            this._sum += results
            if(this._bWriteBack){
                _.forEach(this._writeBackMetricIds, (metricIdWriteBack) => {
                    cell.setCellMetricValue(metricIdWriteBack, results)
                })
            }

        } catch (err){
            this._errorCount += 1
        }

    }

    getResults(): string | number {

        if (this._count > 0)
            return this._sum
        else
            return this._dfltValue
    }

}